import { render, staticRenderFns } from "./DropUpload.vue?vue&type=template&id=066c74de&scoped=true&"
import script from "./DropUpload.vue?vue&type=script&lang=ts&"
export * from "./DropUpload.vue?vue&type=script&lang=ts&"
import style0 from "./DropUpload.vue?vue&type=style&index=0&id=066c74de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c74de",
  null
  
)

export default component.exports